/**
 * Report Builder - Place Health Policy Audit JavaScript
 *
 * Adds the Health Policy Audit compliance chart (MCH-224) to the report
 * canvas. It has no question or filters to pick, so it is placed straight
 * away. The item uses the chart item markup (.canvas-chart-item,
 * .chart-item-content) so the PDF export, title editing and report AI summary
 * treat it like any other chart.
 */

(function () {
  "use strict";

  let placedCount = 0;

  function addHealthPolicyAudit() {
    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (!canvasCharts) {
      return;
    }

    if (window.ReportBuilderUtils?.toggleEmptyMessage) {
      window.ReportBuilderUtils.toggleEmptyMessage(false);
    }

    const id = `report_health_policy_audit_${++placedCount}_${Date.now()}`;

    const container = document.createElement("div");
    container.className = "canvas-chart-item canvas-health-policy-audit-item";
    container.id = `chart_container_${id}`;
    container.setAttribute("data-chart-id", id);

    const header = document.createElement("div");
    header.className = "chart-item-header";
    const displayTitle = "iIMPROVE PIVC ACSQHC Policy Mapping";
    if (window.ReportBuilderUtils?.generateItemHeaderHtml) {
      header.innerHTML = window.ReportBuilderUtils.generateItemHeaderHtml({
        itemId: id,
        displayTitle: displayTitle,
        idAttribute: "data-chart-id",
        itemType: "chart",
        removeButtonClass: "btn-remove-chart",
        removeButtonTitle: "Remove chart",
      });
    } else {
      header.innerHTML = `<div class="chart-item-title"><h4>${displayTitle}</h4></div>`;
    }

    const content = document.createElement("div");
    content.className = "chart-item-content";
    content.id = `chart_content_${id}`;
    content.innerHTML = '<div class="chart-loading">Loading chart...</div>';

    container.appendChild(header);
    container.appendChild(content);
    canvasCharts.appendChild(container);
    container.scrollIntoView({ behavior: "smooth", block: "nearest" });

    if (window.ReportBuilderUtils?.setupMoveButtons) {
      window.ReportBuilderUtils.setupMoveButtons(container, id, "data-chart-id");
    }
    if (window.ReportBuilderUtils?.setupEditTitleButton) {
      window.ReportBuilderUtils.setupEditTitleButton(container, id, "chart");
    }

    const removeBtn = container.querySelector(".btn-remove-chart");
    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        const remove = function () {
          container.remove();
          // The report header is always in the canvas; anything else is an item.
          if (canvasCharts.querySelectorAll(":scope > :not(.canvas-report-header)").length === 0
            && window.ReportBuilderUtils?.toggleEmptyMessage) {
            window.ReportBuilderUtils.toggleEmptyMessage(true);
          }
        };
        if (window.ReportBuilderUtils?.showConfirmationModal) {
          window.ReportBuilderUtils.showConfirmationModal({
            title: "Remove Chart",
            message: "Are you sure you want to remove this chart? This action cannot be undone.",
            confirmText: "Remove",
            cancelText: "Cancel",
            onConfirm: remove,
          });
        } else if (confirm("Are you sure you want to remove this chart?")) {
          remove();
        }
      });
    }

    loadChart(id, content);
  }

  async function loadChart(id, content) {
    try {
      if (!window.reportBuilderData || !window.reportBuilderData.nonce) {
        throw new Error("Report builder data not loaded. Please refresh the page.");
      }
      const formData = new FormData();
      formData.append("action", "load_chart_template");
      formData.append("nonce", window.reportBuilderData.nonce);
      formData.append("chart_type", "health-policy-audit-chart");
      formData.append("chart_id", `chart_${id}`);
      formData.append("tracked_field", "health_policy_audit");

      const response = await fetch(window.reportBuilderData.ajaxurl || "/wp-admin/admin-ajax.php", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.data?.message || "Failed to load chart");
      }

      content.innerHTML = result.data.html;
      // Scripts inserted via innerHTML don't run on their own.
      content.querySelectorAll("script").forEach(function (oldScript) {
        const script = document.createElement("script");
        script.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(script, oldScript);
      });
    } catch (error) {
      console.error("iIMPROVE PIVC ACSQHC Policy Mapping chart failed to load:", error);
      const message = document.createElement("div");
      message.className = "chart-error";
      message.textContent = "Error loading chart: " + error.message;
      content.replaceChildren(message);
    }
  }

  window.ReportBuilderHealthPolicyAudit = {
    addHealthPolicyAudit: addHealthPolicyAudit,
  };
})();
